import axios from '@/libs/api.request'
import { getToken } from '@/libs/util'
import config from '@/config'

// const dictionryBaseUrl = 'http://127.0.0.1:8002/api/1.0/dictionary/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const dictionryBaseUrl = baseDeployUrl + '/api/1.0/dictionary/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getLanguageList = () => {
  return axios.request({
    url: dictionryBaseUrl + 'language/list/all',
    headers: baseHeaders,
    method: 'get'
  })
}
